import { AxiosRequestConfig } from "axios";
import { fetchApi, version1 } from "../../Libs/Config/APIConfig";
import { UpdateUserProfilePayload } from "../../Libs/Types/API-Payloads";
import { BEARER_TOKEN } from "../../Libs/Utils/utils";
interface CustomAxiosRequestConfig<T = unknown> extends AxiosRequestConfig<T> {}

const AuthDataConfig: CustomAxiosRequestConfig = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const apiGetUserProfile = async () => {
  const configWithAuth: CustomAxiosRequestConfig = {
    ...AuthDataConfig,
    headers: {
      ...AuthDataConfig.headers,
      Authorization: `Bearer ${BEARER_TOKEN}`,
    },
  };
  return fetchApi.get(`/api/${version1}/profile/`, configWithAuth);
};

export const apiUpdateUserProfile = async (
  payload: UpdateUserProfilePayload
) => {
  const configWithAuth: CustomAxiosRequestConfig = {
    ...AuthDataConfig,
    headers: {
      ...AuthDataConfig.headers,
      Authorization: `Bearer ${BEARER_TOKEN}`,
    },
  };
  return fetchApi.patch(`/api/${version1}/profile/`, payload, configWithAuth);
};
